import type { AccessControl } from '@schibsted/frapi-schema';

const subscriberOnly = (access: AccessControl): boolean =>
  access && access.restrictions && access.restrictions.includes('closed');

const metered = (access: AccessControl): boolean =>
  access && access.restrictions && access.restrictions.includes('automatic');

const login = (access: AccessControl): boolean =>
  access && access.restrictions && access.restrictions.includes('login');

export const accessLevel = (
  access: AccessControl,
): 'Paid' | 'Meter' | 'Free' | 'Login' =>
  metered(access)
    ? 'Meter'
    : subscriberOnly(access)
      ? 'Paid'
      : login(access)
        ? 'Login'
        : 'Free';

export const accessLevelName = (access: AccessControl): string =>
  accessLevel(access);
